import React from 'react';
import { isMobileView } from './../../Common/Utils';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import * as S from './FooterStyle';
const Footer = (props) => {
  let {data} = props;

  if(!data){
    return null;
  }
  const mobileView  = isMobileView();
  let body=[];

for(let i in data){
  const {block_title,title,links_data} = data[i];
  if(title){

  
  body.push(
    <S.FooterBlock className="footerBlock" key={title+i}>
   <p className="footerHeading" style={{fontWeight:700}}>{title}</p>
   <S.FootInfo className="footInfo">
    {links_data.map((item, idx) => (
      <li key={idx}>
        <a href={item.link || "#"} style={{color:"#0084ff"}}>{item.name}</a>
      </li>
    ))}
    </S.FootInfo >
  </S.FooterBlock>

  )
}
}
  return(
    <S.FooterWrapper>
    <S.FooterContent>
        <S.FooterSection>
          {body}
          
        </S.FooterSection>
        {!mobileView ?<>
        <S.FollowUsSection>
            <div className="flexOne">
                <p className="followTxt">Follow Us</p>
                <div className="makeFlex followIcons">
                    <img width="36px;" height="36px;" className="lazyload" data-src="https://gos3.ibcdn.com/fb_logo-1631109091.png" alt="FB logo"/>
                    <img width="44px;" height="36px;" className="lazyload" data-src="https://gos3.ibcdn.com/twiiter_logo-1631109127.png" alt="Twitter logo"/>
                    <img width="46px;" height="36px;" className="lazyload" data-src="https://gos3.ibcdn.com/youtube_logo-1631109152.png" alt="Youtube logo"/>
                </div>
            </div>
            <div className="flexOne textCenter">
                <p className="followTxt">Book Tickets Faster. Download our apps</p>
                <div className="makeFlex followIcons">
                    <img width="122px;" height="40px;" className="lazyload" data-src="https://gos3.ibcdn.com/google_play-1631109193.png" alt="goggle play"/>
                    <img width="115px;" height="40px;" className="lazyload" data-src="https://gos3.ibcdn.com/app_store-1631109215.png" alt="App Store"/>
                    <img width="147px;" height="40px;" className="lazyload" data-src="https://gos3.ibcdn.com/window_store-1631109238.png" alt="Window Store"/>
                </div>
            </div>
            <div className="flexOne bankInfo">
                <div className="makeFlex followIcons">
                    <img width="32px;" height="16px;" className="lazyload" data-src="https://gos3.ibcdn.com/secured_logo-1631109350.png" alt="verisign secured"/>
                    <img width="26px;" height="16px;" className="lazyload" data-src="https://gos3.ibcdn.com/amex_logo-1631109368.png" alt="american express"/>
                    <img width="30px;" height="16px;" className="lazyload" data-src="https://gos3.ibcdn.com/master_card-1631109388.png" alt="master card"/>
                    <img width="26px;" height="16px;" className="lazyload" data-src="https://gos3.ibcdn.com/visa-1631109407.png" alt="visa"/>
                    <img width="62px;" height="16px;" className="lazyload" data-src="https://gos3.ibcdn.com/rupay-1631109425.png" alt="Rupay"/>
                    <img width="38px;" height="24px;" className="lazyload" data-src="https://gos3.ibcdn.com/iata-1631109447.png" alt="iata"/>
                </div>
            </div>
        </S.FollowUsSection>
        <S.AllRightSection>
            <div className="makeFlex flexOne allRightSubContent">
                {/* <img width="78px;" height="24px;" className="lazyload" data-src="https://gos3.ibcdn.com/go_logo-1631109297.png" alt="GiLogo"/> */}
                <img width="47px;" height="24px;" className="lazyload" data-src="https://gos3.ibcdn.com/redbus_logo-1631109320.png" alt="RedBus"/>
            </div>
            {/* <div className="flexOne copyrightText"> © 2019 ibibogroup. All rights reserved.</div> */}
        </S.AllRightSection>
    </> :null}
    </S.FooterContent>
    </S.FooterWrapper>
);
      }
export default Footer;
